form {
  h2 {
    color: #222;
    text-transform: none;
    font-size: 26px;
    line-height: 1.25;
    font-weight: 600;
    margin-bottom: 32px;
  }

  .success-message {
    color: green;
  }

  button {
    font-weight: 600;
    font-size: 18px;
    text-transform: none;
    background-color: #0076c0;
    color: #fff;
    display: inline-block;
    cursor: pointer;
    padding: 10px 20px;
    border: 0;
    width: 185px;

    &:focus {
      outline: none;
    }

    &:hover {
      background-color: #0169aa;
    }
  }

  .buttons-set {
    display: flex;

    .required {
      font-size: 16px;
      font-weight: 500;
      color: #F12A22;
      justify-content: flex-end;
      display: flex;
      width: 50%;
      padding-left: 10px;
    }
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      position: relative;
      margin-bottom: 20px;

      label {
        position: absolute;
        top: 5px;
        left: 16px;
        font-size: 14px;
        line-height: 19px;
        font-weight: 500;
        color: #222;
        margin: 0;

        em {
          color: #f68a33;
        }
      }

      input:not([type='checkbox']),
      textarea {
        background-color: #fff;
        border: 1px solid #cacaca;
        padding: 16px 16px 0 16px;
        height: 50px;
        width: 100%;
        box-sizing: border-box;
      }

      input:invalid {
        border: 2px solid red;
      }

      textarea {
        padding: 24px 16px 0 16px;
        min-height: 185px;
      }

      .validation-advice {
        clear: both;
        margin-top: 5px;
        font-style: italic;
        text-align: left;
        color: #f00000;
        font-size: 16px;
        font-weight: 500;
      }

      &.gdpr-conditions {
        label {
          display: flex;
          align-items: center;
          position: relative;
          line-height: 20px;
          font-size: 14px;
          top: 0;
          left: 0;

          a {
            display: inline-block;
            margin-left: 5px;
            color: #0076c0;
          }

          input {
            height: 20px;
            width: 20px;
            margin-right: 10px;
          }
        }

        p {
          margin-left: 13px;
        }
      }
    }
  }
}
